<div class="d-flex flex-column gap-16 gap-16-768 confirmation-card">
  @if (icon) {
    <div class="icon-circle d-flex align-items-center justify-content-center p-10"
      [style.background-color]="iconBgColor">
      <img [src]="icon" alt="action icon">
    </div>
  }
  <div class="d-flex flex-column gap-6 gap-6-768">
    <h2 class="heading2-768 font-bold heading2 text-black">{{title}}</h2>
    <p class="paragraph-Medium paragraph-large-768 open-sans txt-charcoalGrey500">{{description}}</p>
  </div>
  <ng-content></ng-content>
</div>
<div class="d-flex flex-column flex-md-row gap-16 gap-24-768 confirmation-buttons p-24">
  @if (showCancel) {
    <button
      class="btn-primary-red paragraph-extra-Medium-768 font-semibold flex-1"
    (click)="cancel()">{{cancelLabel}}</button>
  }
  <button [class]="confirmBtnClass + ' d-flex align-items-center justify-content-center paragraph-extra-Medium-768 font-semibold cursor-pointer' + (showCancel ? ' flex-1' : ' btn-auto-width')"
    [disabled]="disabled"
  (click)="confirm()">{{confirmLabel}}</button>
</div>
